import CmDeliveryNoteNumber from './CmDeliveryNoteNumber';
import Comment from './Comment';
import CompletedDate from './CompletedDate';
import Created from './Created';
import CreatorUser from './CreatorUser';
import GrossPrice from './GrossPrice';
import Id from './Id';
import IsStockist from './IsStockist';
import NetPrice from './NetPrice';
import ReceiptNumber from './ReceiptNumber';
import ReferenceNumber from './ReferenceNumber';
import Status from './Status';
import Storage from './Storage';
import Supplier from './Supplier';
import SupplierOrder from './SupplierOrder';
import Updated from './Updated';

export const compareTypes = {
  net_price: 'number',
  gross_price: 'number',
};

export const labels = {
  Id: 'Id',
  ReceiptNumber: 'Bizonylatszám',
  CmDeliveryNoteNumber: 'CM szlev száma',
  Status: 'Státusz',
  Supplier: 'Beszállító',
  Storage: 'Raktár',
  IsStockist: 'Besz. ár végleges',
  CompletedDate: 'Teljesítés dátuma',
  SupplierOrder: 'Kapcsolódó beszállítói megrendelés',
  CreatorUser: 'Rögzítette',
  NetPrice: 'Nettó ár',
  GrossPrice: 'Bruttó ár',
  ReferenceNumber: 'Hivatkozási szám',
  Comment: 'Megjegyzés',
  Created: 'Létrehozva',
  Updated: 'Módosítva',
};

export const allColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'ReceiptNumber',
}, {
  value: 'CmDeliveryNoteNumber',
}, {
  value: 'Supplier',
}, {
  value: 'Storage',
}, {
  value: 'IsStockist',
}, {
  value: 'CompletedDate',
}, {
  value: 'SupplierOrder',
}, {
  value: 'CreatorUser',
}, {
  value: 'NetPrice',
}, {
  value: 'GrossPrice',
}, {
  value: 'Comment',
}, {
  value: 'Updated',
}, {
  value: 'Created',
}, {
  value: 'Status',
}];

export const defaultColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'ReceiptNumber',
}, {
  value: 'CmDeliveryNoteNumber',
}, {
  value: 'ReferenceNumber',
}, {
  value: 'Status',
}, {
  value: 'IsStockist',
}, {
  value: 'Supplier',
}, {
  value: 'Storage',
}, {
  value: 'SupplierOrder',
}, {
  value: 'CompletedDate',
}, {
  value: 'CreatorUser',
}, {
  value: 'NetPrice',
}, {
  value: 'Created',
}, {
  value: 'Comment',
}];

export const defaultSort = {
  prop: Created.propName,
  order: 'ascending'
};

export default {
  Id,
  ReceiptNumber,
  CmDeliveryNoteNumber,
  ReferenceNumber,
  Status,
  Supplier,
  Storage,
  SupplierOrder,
  CompletedDate,
  CreatorUser,
  NetPrice,
  GrossPrice,
  IsStockist,
  Comment,
  Created,
  Updated,
};
